import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getChequeByID } from 'src/redux/slices/cheque';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import ChequeNewEditForm from '../cheque-new-edit-form';
import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function ChequeEditView({ id }: Props) {
  const { item, status, error } = useAppSelector((state) => state.cheque);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getChequeByID({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load cheque details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.cheque.root()}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Cheques
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit Cheque"
        links={[
          {
            name: 'Cheque',
            href: paths.dashboard.cheque.root(),
          },
          { name: 'Edit Cheque' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <ChequeNewEditForm currentCheque={item} />
    </Container>
  );
}
